import { getFormValidationAdornment } from '@eventbrite/design-ops-ds';
import React from 'react';
import { isPromoCodeOpenByDefault } from '../../utils/statsig';
import { PromoCodeCtaButton } from './PromoCodeCtaButton';
import { PromoCodeCtaText } from './PromoCodeCtaText';

export const getValidationAdornment = (hasError: boolean, isValid: boolean) => {
    return getFormValidationAdornment({ hasError, isValid });
};

export const getInternalCta = ({
    ctaText,
    isDisabled,
    isLoading,
    isSubmitFailed,
    shouldShowInternalCta,
    onClick,
}: {
    ctaText: string;
    isDisabled: boolean;
    isLoading: boolean;
    isSubmitFailed: boolean;
    shouldShowInternalCta: boolean;
    onClick: () => any;
}) => {
    const promoCodeOpenedByDefault = isPromoCodeOpenByDefault();
    if (
        (!promoCodeOpenedByDefault && shouldShowInternalCta) ||
        (promoCodeOpenedByDefault && !isSubmitFailed)
    ) {
        return (
            <PromoCodeCtaText
                isLoading={isLoading}
                isDisabled={isDisabled}
                ctaText={ctaText}
                onClick={onClick}
            />
        );
    }

    return null;
};

export const getExternalCta = ({
    isDisabled,
    onClick,
    shouldShowExternalCta,
}: {
    isDisabled: boolean;
    onClick: () => any;
    shouldShowExternalCta: boolean;
}) => {
    return shouldShowExternalCta ? (
        <PromoCodeCtaButton isDisabled={isDisabled} onClick={onClick} />
    ) : null;
};
